import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/statuses';

export class StateService extends RestServiceConnection {

    listStates = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getStateById = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleStateStatus = async (statusId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { statusId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createState = async (user: FormData) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editState = async (user: FormData) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiStates = async (statusesIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { statusesIds }
        }, true);
        return this;
    }

    toggleDraftState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-draft-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleInitialState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-initial-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleSatisfactoryState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-satisfactory-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleUnsatisfactoryState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-unsatisfactory-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleRequiresKoReasonState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-requires-ko-reason-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleValidForNetworkSettlementState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-valid-for-network-settlement-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleNegativeForNetworkSettlementState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-negative-for-network-settlement-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleClientInvoiceState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-client-invoice-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleTutorInvoiceState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-tutor-invoice-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleInternalInvoiceState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-internal-invoice-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleScoreDeliveryState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-score-delivery-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleScoreRemoveState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-score-remove-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    togglePaidStatus = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-paid-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleUnpaidStatus = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-unpaid-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleSendOrderCoursesInformationEmailState = async (statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle-send-order-courses-information-email-status',
            data: { statusId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    updateStateOrder = async (statusId: string, action: 'up' | 'down') => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status-order',
            data: { statusId, action },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listStatusesForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-statuses-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

}
